import React, { useEffect, useState } from 'react';
import { Chart } from 'react-chartjs-2'; // <--- ΑΛΛΑΓΗ 1: Χρησιμοποιούμε το γενικό Chart αντί για το Line
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  BarController,   // <--- ΑΛΛΑΓΗ 2: Προσθήκη BarController
  LineController,  // <--- ΑΛΛΑΓΗ 2: Προσθήκη LineController
  Title,
  Tooltip,
  Legend,
  TimeScale,
  Filler
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import { el } from 'date-fns/locale';
import api from '../api';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  BarController,   // <--- ΠΡΟΣΘΗΚΗ ΕΔΩ
  LineController,  // <--- ΠΡΟΣΘΗΚΗ ΕΔΩ
  Title,
  Tooltip,
  Legend,
  TimeScale,
  Filler 
);

const COLORS = [
  { border: 'rgb(75, 192, 192)', bg: 'rgba(75, 192, 192, 0.1)' },
  { border: 'rgb(255, 99, 132)', bg: 'rgba(255, 99, 132, 0.1)' },
  { border: 'rgb(54, 162, 235)', bg: 'rgba(54, 162, 235, 0.1)' },
  { border: 'rgb(255, 206, 86)', bg: 'rgba(255, 206, 86, 0.1)' }
];

const isAnyDoorOpen = (doorStatus) => {
    if (doorStatus === null || doorStatus === undefined || doorStatus === false || doorStatus === 0) return false;
    if (typeof doorStatus === 'object') return Object.values(doorStatus).some(val => val === true || val === "true" || val === 1);
    return doorStatus === true || doorStatus === "true" || doorStatus === 1;
};

function TemperatureChart({ deviceIds, hours, devices, startDate, endDate }) {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError('');

      try {
          const params = { deviceIds: deviceIds.join(',') };
          if (startDate && endDate) {
            params.startDate = (startDate instanceof Date) ? startDate.toISOString() : new Date(startDate).toISOString();
            params.endDate = (endDate instanceof Date) ? endDate.toISOString() : new Date(endDate).toISOString();
          } else {
            params.hours = hours;
          }
          const response = await api.get('/api/dashboard/temperatures', { params });

        const data = response.data.data;
        const groupedData = {};
        
        data.forEach(item => {
          if (!groupedData[item.deviceId]) {
            groupedData[item.deviceId] = [];
          }
          groupedData[item.deviceId].push({
            x: new Date(item.timestamp),
            y: item.temperature,
            doorOpen: isAnyDoorOpen(item.doorOpen) 
          });
        });

        let datasets = [];
        
        Object.keys(groupedData).forEach((deviceId, index) => {
          const device = devices.find(d => d.id === parseInt(deviceId));
          const deviceName = device ? 
            `${device.locationName} - ${device.name}` : 
            `Device ${deviceId}`;
          
          const color = COLORS[index % COLORS.length];

          // 1. Δεδομένα Θερμοκρασίας (Γραμμή)
          datasets.push({
            type: 'line',
            label: deviceName,
            data: groupedData[deviceId],
            borderColor: color.border,
            backgroundColor: color.bg,
            tension: 0.4,
            pointRadius: 0,
            pointHoverRadius: 6,
            borderWidth: 2,
            yAxisID: 'y',
            order: 1 // Ζωγραφίζεται από πάνω
          });

          // 2. Δεδομένα Πόρτας (Κάθετες Λωρίδες Φόντου - Bars)
          datasets.push({
            type: 'bar',
            label: `Πόρτα: ${deviceName}`,
            data: groupedData[deviceId]
                    .filter(p => p.doorOpen)
                    .map(p => ({ x: p.x, y: 1 })),
            backgroundColor: 'rgba(255, 0, 0, 0.15)', // Ημιδιαφανές κόκκινο
            barThickness: 8, // Σταθερό πάχος λωρίδας
            yAxisID: 'yDoorBg', // Κρυφός άξονας
            order: 2 // Ζωγραφίζεται στο φόντο
          });

          // 3. Limit Lines (Min/Max)
          if (device && device.DeviceAlert && device.DeviceAlert.alertsEnabled) {
              const minTemp = parseFloat(device.DeviceAlert.minTemp);
              const maxTemp = parseFloat(device.DeviceAlert.maxTemp);
              const limitDataPoints = groupedData[deviceId].map(p => p.x);

              datasets.push({
                  type: 'line',
                  label: `Max Limit (${device.name})`,
                  data: limitDataPoints.map(x => ({ x, y: maxTemp })),
                  borderColor: 'rgba(255, 99, 132, 0.5)',
                  borderWidth: 1,
                  borderDash: [5, 5],
                  pointRadius: 0,
                  fill: false,
                  yAxisID: 'y',
                  order: 3
              });

              datasets.push({
                  type: 'line',
                  label: `Min Limit (${device.name})`,
                  data: limitDataPoints.map(x => ({ x, y: minTemp })),
                  borderColor: 'rgba(54, 162, 235, 0.5)',
                  borderWidth: 1,
                  borderDash: [5, 5],
                  pointRadius: 0,
                  fill: false,
                  yAxisID: 'y',
                  order: 3
              });
          }
        });

        setChartData({ datasets });

      } catch (err) {
        setError('Σφάλμα κατά τη φόρτωση δεδομένων');
      } finally {
        setLoading(false);
      }
    };

    if (deviceIds.length > 0) {
      fetchData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceIds, hours, startDate, endDate]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false
    },
    plugins: {
      legend: {
        position: 'top',
        labels: {
            filter: function(item) {
                return !item.text.includes('Limit') && !item.text.includes('Πόρτα');
            },
            usePointStyle: true,
            padding: 15
        }
      },
      title: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => {
             if (context.dataset.label.includes('Limit')) return null;
             
             if (context.dataset.label.includes('Πόρτα')) {
                 return `🚪 ${context.dataset.label.replace('Πόρτα: ', '')}: ΑΝΟΙΧΤΗ`;
             }
             return `${context.dataset.label}: ${context.parsed.y.toFixed(1)}°C`;
          }
        }
      }
    },
    scales: {
      x: {
        type: 'time',
        time: {
          unit: (() => {
            if (startDate && endDate) {
              const s = new Date(startDate);
              const e = new Date(endDate);
              const hoursRange = Math.abs(e - s) / 36e5;
              if (hoursRange <= 6) return 'hour';
              if (hoursRange <= 48) return 'hour';
              return 'day';
            }
            return hours <= 6 ? 'hour' : hours <= 24 ? 'hour' : 'day';
          })(),
            displayFormats: { hour: 'HH:mm', day: 'dd/MM HH:mm' },
            tooltipFormat: 'dd/MM/yyyy HH:mm'
        },
        adapters: { date: { locale: el } },
        grid: { display: false }
      },
      y: {
        type: 'linear',
        position: 'left',
        ticks: {
          callback: (value) => `${parseFloat(value).toFixed(1)}°C` 
        },
        grid: { color: 'rgba(0, 0, 0, 0.05)' }
      },
      yDoorBg: {
        type: 'linear',
        position: 'right',
        display: false,
        min: 0,
        max: 1, 
        grid: { display: false }
      }
    }
  };

  if (loading) return <div className="text-center py-5">Φόρτωση...</div>;
  if (error) return <div className="alert alert-danger">{error}</div>;
  if (!chartData || chartData.datasets.length === 0) return <div className="alert alert-info">Δεν υπάρχουν δεδομένα.</div>;

  return (
    <div style={{ height: '400px' }}>
      {/* ΑΛΛΑΓΗ 3: Χρησιμοποιούμε Chart αντί για Line */}
      <Chart type="line" data={chartData} options={options} /> 
    </div>
  );
}

export default TemperatureChart;